<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />

            <td class="data-table__cell">
              <router-link
                class="data-table__truncate"
                :title="`/${item.url}`"
                :to="`/redirects/${item.id}/edit`"
              >
                /{{ item.url }}
              </router-link>
            </td>
            <td class="data-table__cell">
              <router-link
                class="data-table__truncate"
                :title="item.absolute_url"
                :to="`/redirects/${item.id}/edit`"
              >
                {{ item.absolute_url }}
              </router-link>
            </td>
            <td class="data-table__cell">
              <router-link
                class="data-table__truncate"
                :title="item.title"
                :to="`/redirects/${item.id}/edit`"
              >
                {{ item.title }}
              </router-link>
            </td>
            <td class="text-center nowrap">
              <Actions
                hide-show
                hide-duplicate
                :path="`/redirects/${item.id}`"
                @destroy="$emit('destroy', item)"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "From URL",
          align: "start",
          value: "url",
          sortable: true,
        },
        {
          text: "Destination URL",
          align: "start",
          value: "absolute_url",
          sortable: true,
        },
        {
          text: "Name",
          align: "start",
          value: "title",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.data-table__cell {
  max-width: 280px;
}

.data-table__truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
